import { useMutation, useQueryClient } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

type Parameters = {
  companyId: string
  projectId: string
  topicIds: string[]
}

const handleDeleteTopics = async ({
  companyId,
  projectId,
  topicIds,
}: Parameters): Promise<{
  status: 'error' | 'success'
  message?: string
}> => {
  try {
    const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/topics/remove`
    const response = await axios.patch(url, {
      project_id: projectId,
      topic_ids: topicIds,
    })
    return response.data
  } catch (error) {
    return extract.error(error)
  }
}

export const useDeleteProjectTopics = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: Parameters) => handleDeleteTopics(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['project-topics'])
    },
  })
}
